import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20illustration%20of%20a%20magical%20reading%20nook%20filled%20with%20stacked%20comic%20books%2C%20soft%20pillows%2C%20warm%20peach%20and%20pink%20ambient%20lighting%2C%20whimsical%20floating%20sparkles%2C%20dreamy%20pastel%20atmosphere%2C%20cute%20and%20inviting%20bookstore%20corner%2C%20soft%20anime-inspired%20art%20style%2C%20comforting%20and%20relaxing%20vibe&width=1600&height=900&seq=hero-bg-taotao&orientation=landscape"
          alt="桃桃漫画网 - 韩国漫画无删减下拉式在线阅读"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-[800px] mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 leading-tight">
            韩国漫画无删减
            <span className="block mt-2 text-primary-400">下拉式免费在线阅读</span>
          </h1>
          <p className="text-sm md:text-base text-background-200 max-w-xl mx-auto mb-8 leading-relaxed">
            桃桃漫画网为您提供海量韩国漫画资源，无删减原版内容，可爱风格韩漫免费阅读。
            下拉式操作轻松流畅，随时随地畅享漫画乐趣。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              开始阅读
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-primary-400">1000+</p>
              <p className="text-xs text-background-300 mt-1">韩国漫画资源</p>
            </div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-primary-400">50万+</p>
              <p className="text-xs text-background-300 mt-1">活跃读者用户</p>
            </div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-primary-400">每日更新</p>
              <p className="text-xs text-background-300 mt-1">最新章节连载</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}